export default class HeroVideo {
	constructor() {
		this.video = document.getElementById('hero-video');

		if (!this.video) return;
		
		this.controls = {
			mute: document.querySelector('.js-video-controls .mute-control'),
			pause: document.querySelector('.js-video-controls .pause-control')
		};
		this.icons = {
			mute: this.controls.mute && this.controls.mute.querySelector('.icon'),
			pause: this.controls.pause && this.controls.pause.querySelector('.icon')
		};

		this.events();
	}

	onPause() {
		if (this.video.paused) {
			this.video.play();
			this.icons.pause.classList.remove('stop');
		} else {
			this.video.pause();
			this.icons.pause.classList.add('stop');
		}
	}

	onMute() {
		if (this.video.muted) {
			this.icons.mute.classList.add('stop');
		} else {
			this.icons.mute.classList.remove('stop');
		}
		this.video.muted = !this.video.muted;
	}

	events() {
		this.controls.pause && this.controls.pause.addEventListener('click', this.onPause.bind(this));
		this.controls.mute && this.controls.mute.addEventListener('click', this.onMute.bind(this));

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					this.video.pause();
					this.icons.pause && this.icons.pause.classList.add('stop');
				} else {
					this.video.play();
					this.icons.pause && this.icons.pause.classList.remove('stop');
				}
			});
		}, {});

		observer.observe(this.video);
	}
}
